<template>
  <div class="ui basic segment">
    <div class="ui container grid">
      <div class="five wide column">
        <report-list ref="report_list" @load_report="load_report" />
      </div>
      <div class="eleven wide column">
        <report-composer
          :templates="templates"
          ref="report_composer"
          @deleted="refresh_list"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import ReportComposer from "./ReportComposer";
import ReportList from "./ReportList";

export default {
  name: "ReportComposerIndex",
  components: { ReportComposer, ReportList },
  filters: filters,
  data() {
    return {
      header_buttons: [{ icon: "blue save", click: this.save }],
      reports_by_module: [],
      templates: [],
    };
  },
  methods: {
    save() {
      let vm = this;
      let data = vm.$refs.report_composer.get_report_data();
      local_api(vm, "post", "/report_composer/do-save", data)
        .then(() => {
          vm.$alertify.success(vm.$t("report saved"));
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    load_report(report) {
      this.$refs.report_composer.load_report(report);
    },
    refresh_list() {
      this.$refs.report_list.init();
    },
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(vm, "post", "/report_composer/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
};
</script>
